import { LOYALTY_THEME } from "@tcp/core/src/constants/loyaltyTiers.constants";

const getLoyaltyThemeColor = (isLoyaltyTieringEnabled, currentTier, plccUser, colorPalette) => {
  if(isLoyaltyTieringEnabled && currentTier) {
    if (currentTier === LOYALTY_THEME.BRONZE) {
      return colorPalette.green[300];
    } else if (currentTier === LOYALTY_THEME.SILVER) {
      return colorPalette.blue[1700];
    } else if (currentTier === LOYALTY_THEME.GOLD) {
      return colorPalette.gray[1100];
    }
  } else {
    return plccUser ? colorPalette.blue[500] : colorPalette.orange[800]
  }
};

export { getLoyaltyThemeColor };
